import React, { useEffect, useState } from "react";
import styles from './Home.module.scss';
import DashboardCard from "../../../components/dashboardCard/DashboardCard";
import StudentTrendChart from "../../../components/studentTrendChart/StudentTrendChart";
import LoadingOverlay from "../../../components/loadingOverlay/LoadingOverlay";
import { useToasts } from "../../../contexts/ToastContext";
import axiosClient from "../../../api/axiosClient";

const SummaryView = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({});
  const { showToast } = useToasts();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      await axiosClient.get('dashboard/student')
        .then((response) => setData(response.data))
        .catch((error) => showToast(error.message, 'error'))
        .finally(() => setIsLoading(false));
    };
    fetchData();
  }, [showToast]);

  return (
    <>
      {isLoading && <LoadingOverlay />}
      <h2>Summary</h2>
      <div className={styles.cardList}>
        <div className={`${styles.cardItem} ${styles.item25}`}>
          <DashboardCard
            title='Evaluations Completed'
            progress={{
              total: data?.totalEvaluations ?? 0,
              completed: data?.completedEvaluations ?? 0,
              color: '#388147'
            }}
            daysText="This Semester"
          />
        </div>
        <div className={styles.cardItem}>
          <DashboardCard
            title='Total Clinical Hours'
            count={{ count: 0, text: 'Hours', type: 'primary' }}
            daysText="This Semester"
          />
        </div>
        <div className={styles.cardItem}>
          <DashboardCard
            title='Non-Clinical Day'
            count={{ count: data?.totalNonClinicalDay ?? 0, type: 'green' }}
            daysText="This Semester"
          />
        </div>
        <div className={styles.cardItem}>
          <DashboardCard
            title='Cases Submitted'
            count={{ icon: 'file-text', count: data?.submittedCaseLogs ?? 0, type: 'green' }}
            daysText="This Semester"
          />
        </div>
        <div className={styles.cardItem}>
          <DashboardCard
            title='Pending Cases'
            count={{ icon: 'file-text', count: data?.pendingCaseLogs ?? 0, type: 'red' }}
            daysText="This Semester"
          />
        </div>
      </div>
      <StudentTrendChart />
    </>
  );
};

export default SummaryView;
